import { SET_AUTH, PURGE_AUTH, SET_ERROR, PURGE_ERROR } from "./mutations.type";

const state = {
  errors: null,
  user: {},
  isAuthenticated: false
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [PURGE_ERROR](state) {
    state.errors = null;
  },
  [SET_AUTH](state, user) {
    //    console.log("認証保存");
    //    console.debug("認証保存情報:" + JSON.stringify(user));
    state.isAuthenticated = true;
    state.user = user;
  },
  [PURGE_AUTH](state) {
    //    console.log("認証情報削除");
    state.isAuthenticated = false;
    state.user = {};
    state.errors = null;
    //    console.debug(JSON.stringify(state));
  }
};

export default {
  state,
  mutations,
  getters
};
